module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0122-mjigyoba/mjigyoba.component.css
// module id = ./src/app/a0122-mjigyoba/mjigyoba.component.css
// module chunks = main